import type { StateStore } from 'oidc-client-ts';
import { declareStorageDomain } from '../storage/storageGate';

const PREFIX = 'oidc.';

const storage = declareStorageDomain({
    name: 'ximi-oidc-session',
    // Ceinture-bretelles : signOutXimiSso (end_session + removeUser) a normalement déjà
    // retiré le user ; ce sweep garantit qu'aucune clé oidc.* (user, états PKCE) ne survit.
    onLogout: async (s) => {
        const keys = await s.getKeys();
        const oidcKeys = keys.filter((key) => key.startsWith(PREFIX));
        await Promise.all(oidcKeys.map((key) => s.remove(key)));
    },
    // Bascule act-as : la session SSO du Pro DOIT survivre — le jeton accompagné porte son
    // ssoSub, et chaque requête continue d'envoyer sa preuve X-Ximi-Sso-Token (décision 7
    // du plan sessions-accompagnées). La purger tuerait la session accompagnée à la
    // première requête d'un Pro Ximi.
    onIdentitySwitch: async () => {}
});

/**
 * oidc-client-ts StateStore backed by our generic storage gate, so the SSO
 * user + PKCE state are persisted through the single app storage backend
 * (@capacitor/preferences). Swapping to native secure storage later = one change
 * in the wrapper, transparent to oidc.
 */
export class PreferencesStateStore implements StateStore {
    async set(key: string, value: string): Promise<void> {
        await storage.setString(PREFIX + key, value);
    }

    async get(key: string): Promise<string | null> {
        return storage.getString(PREFIX + key);
    }

    async remove(key: string): Promise<string | null> {
        const value = await storage.getString(PREFIX + key);
        await storage.remove(PREFIX + key);
        return value;
    }

    async getAllKeys(): Promise<string[]> {
        const keys = await storage.getKeys();
        return keys.filter((key) => key.startsWith(PREFIX)).map((key) => key.slice(PREFIX.length));
    }
}
